import { Form } from "../../interfaces/forms";
import DateForm from "./DateForm";
import NumberForm from "./NumberForm";
import SelectForm from "./SelectForm";
import TextForm from "./TextForm";
interface ComponentFormProps {
  field: Form;
}

function ComponentForm(props: ComponentFormProps) {
  const renderSwitch = (field: Form) => {
    switch (field.fieldType) {
      case "text":
        return <TextForm field={field} />;
      case "select":
        return <SelectForm field={field} />;
      case "number":
        return <NumberForm field={field} />;
      case "date":
        return <DateForm field={field} />;
      default:
        return null;
    }
  };
  return <>{renderSwitch(props.field)}</>;
}

export default ComponentForm;
